module.exports = __webpack_public_path__ + "static/media/air-airship-aviation-svgrepo-com.d29c6639.svg";